import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade/common/pages/alert-details/lang/index';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { exportAlarmList } from '@blade/common/api/alarm-center';
import searchBox from '@blade-sxp/alarm-center/pages/components/form-filter/search-box.vue';
import { AlarmCenterModule } from '@blade-sxp/alarm-center/store/index';
import { debounce } from 'lodash';
let default_1 = class default_1 extends Vue {
    userLastOperationRecord;
    fullSkDialogVisible = false;
    searchBar = false;
    permissionlevel = permissionlevel;
    form = {
        keyWord: this.$props.userLastOperationRecord?.keyWord || '',
    };
    onInputDebounced = debounce(this.onInput, 500, { trailing: true });
    refreshBtn = debounce(this.updateSearchBox, 800);
    get screenNum() {
        return AlarmCenterModule.screenNum;
    }
    onUpdateUserLastOperationRecord() {
        this.form.keyWord = this.userLastOperationRecord.keyWord;
    }
    onInput() {
        const newObj = {
            ...this.form,
        };
        AlarmCenterModule.updateSearchdata(newObj);
        this.$emit('updateAlarmList');
    }
    updateSearchBox() {
        this.$emit('updateAlarmList');
    }
    getScreenNum() {
        return this.screenNum > 0;
    }
    handleExport() {
        const reqParam = {
            ...AlarmCenterModule.searchdata,
            size: 10000,
        };
        exportAlarmList({ ...reqParam }).then((res) => {
            if (res) {
                window.location.href = process.env.NODE_ENV === 'development' ? `${res}` : res;
            }
        });
    }
    handleDialog() {
        this.fullSkDialogVisible = true;
    }
    handleSearchBox() {
        this.searchBar = !this.searchBar;
    }
};
__decorate([
    Prop()
], default_1.prototype, "userLastOperationRecord", void 0);
__decorate([
    Watch('userLastOperationRecord')
], default_1.prototype, "onUpdateUserLastOperationRecord", null);
default_1 = __decorate([
    Component({
        name: 'FormFilter',
        components: { SecondaryVerification, AuthNewitem, searchBox },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
